import React from 'react';
import { Stack, Typography } from '@mui/material';
import IdCardPreview from './IdCardPreview';
import { layoutOf } from './catalog';
import type { CardFaceProps } from './render/faces/shared';

interface Props extends CardFaceProps {
  /** On-screen width of a landscape card; a portrait card is sized to match its height. */
  width: number;
}

const SideLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 0.8, fontWeight: 600 }}>
    {children}
  </Typography>
);

/** Both sides of a card — stacked when landscape, side by side when portrait. */
const CardSidesPreview: React.FC<Props> = ({ width, ...face }) => {
  const portrait = layoutOf(face.design.layout).orientation === 'portrait';
  const cardWidth = portrait ? width * 0.63 : width;
  const sides = face.design.back.enabled ? (['front', 'back'] as const) : (['front'] as const);
  return (
    <Stack direction={portrait ? 'row' : 'column'} spacing={portrait ? 4 : 3.5} alignItems="center" justifyContent="center">
      {sides.map(side => (
        <Stack key={side} spacing={1.25} alignItems="center">
          <IdCardPreview side={side} width={cardWidth} {...face} />
          <SideLabel>{side === 'front' ? 'Front' : 'Back'}</SideLabel>
        </Stack>
      ))}
    </Stack>
  );
};

export default CardSidesPreview;
